import React from 'react'
import Layout from '@cinch/oxd-layouts/regular/src'
import Wrapper from '@cinch/oxd-components/wrapper/src'
import Hero from '@cinch/oxd-components/hero/src'
import { Text } from '@cinch-labs/design-system'

import * as styles from './covid-information.module.css'
import IconContentBlock from '@cinch/oxd-components/icon-content-block/icon-content-block.component'

interface CovidInformationPageProps {
  i18n: Cinch.WebAppTranslations['covidInformation']
  heroImage: any
}

const CovidInformationPage: React.FC<CovidInformationPageProps> = ({ i18n, heroImage }) => {
  const hero = <Hero heading={i18n.heroTitle} content={i18n.heroBody} heroImage={heroImage} />

  const mapContent = (content: any) => {
    const body = content.body.split('\n').map((x: any, i: number) => <p key={i}>{x}</p>)

    return {
      ...content,
      body: body,
    }
  }

  return (
    <Layout hero={hero} isFluid={true} hasBlendedFooter={true}>
      <Wrapper>
        <div className={styles.container}>
          <Text className={styles.title} element="h3" fontWeight="bold" fontSize="xl" lineHeight="display">
            {i18n.title}
          </Text>
          {i18n.contentBlocks.map((content) => (
            <IconContentBlock key={content.title} {...mapContent(content)} />
          ))}
        </div>
      </Wrapper>
    </Layout>
  )
}

export default CovidInformationPage
